import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_TASK_ACTION_SUCCESS,
  FETCH_TASK_ACTION_SUCCESS,
  GET_TASK_ACTION_SUCCESS,
  SAVE_TASK_ACTION_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSuccess} from "./Common";
import {getUser} from "./Auth";
import {arrayToCSV, downloadCSV} from "../../util/methods";
import {message} from "antd";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_TASK_ACTION_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_TASK_ACTION_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_TASK_ACTION_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_TASK_ACTION_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {taskAction} = store.getState();
      const {query} = taskAction;
      const response = await axios.get(`/task-action?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {taskAction} = store.getState();
      const {query} = taskAction;
      const response = await axios.get(`/task-action/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/task-action`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if(!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/task-action');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/task-action/${id}`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }

      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/task-action');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/task-action/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/task-action/${id}`);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
